/*
  FK Mix Bundle JS — no checkout blocker version

  Customer behavior:
  - Normal variant card Select button toggles that variant between 0 and 1.
  - Plus/minus changes individual variant quantity.
  - "All variants" card/button toggles every available variant to quantity 1.
  - "All variants" does NOT directly add to cart.
  - Customer still clicks Add bundle to cart / Buy bundle now after selection.

  Cart behavior:
  - Checkout is NEVER blocked.
  - Cart message is now only a bundle discount reminder.
  - Quantity logic counts actual cart line quantity.
    Example: 1 variant with quantity 3 = 3pcs bundle discount unlocked.
*/

(function () {
  if (window.FKMixBundleLoaded) return;
  window.FKMixBundleLoaded = true;

  var CART_URL = '/cart.js';
  var ADD_URL = '/cart/add.js';

  var cartAdvisorState = {
    checked: false,
    message: ''
  };

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root ? root.querySelectorAll(selector) : []);
  }

  function toInt(value, fallback) {
    var num = parseInt(value, 10);
    return Number.isFinite(num) ? num : fallback;
  }

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
  }

  function replaceRemaining(text, remaining) {
    return String(text || '').replace(/\{remaining\}/g, String(remaining));
  }

  function fetchCart() {
    return fetch(CART_URL, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not read cart.');
      return response.json();
    });
  }

  function setButtonLoading(button, loading, loadingText, normalText) {
    if (!button) return;

    if (loading) {
      button.dataset.normalText = button.textContent;
      button.textContent = loadingText || 'Adding...';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else {
      button.textContent = normalText || button.dataset.normalText || button.textContent;
      button.removeAttribute('aria-busy');
    }
  }

  function updateCartCountBubbles(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    [
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble span:not(.visually-hidden)',
      '[data-cart-count]',
      '[data-header-cart-count]'
    ].forEach(function (selector) {
      qsa(document, selector).forEach(function (node) {
        node.textContent = String(cart.item_count);
      });
    });
  }

  function announce(message) {
    var live = qs(document, '[data-fk-global-live]');

    if (!live) {
      live = document.createElement('div');
      live.setAttribute('data-fk-global-live', '');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      live.className = 'visually-hidden';
      document.body.appendChild(live);
    }

    live.textContent = message;
  }

  function initMixBundle(root) {
    if (!root || root.dataset.fkInitialized === 'true') return;
    root.dataset.fkInitialized = 'true';

    var minQty = toInt(root.dataset.minQty, 3);
    var maxPerVariant = toInt(root.dataset.maxPerVariant, 99);

    var discountEnabled = root.dataset.discountEnabled === 'true';
    var discountQty = toInt(root.dataset.discountQty, minQty);
    var discountLocked = root.dataset.discountLocked || 'Add {remaining} more to unlock bundle discount.';
    var discountUnlocked = root.dataset.discountUnlocked || 'Bundle discount unlocked.';

    var secondRewardEnabled = root.dataset.freeShippingEnabled === 'true';
    var secondRewardQty = toInt(root.dataset.freeShippingQty, 0);
    var secondRewardLocked = root.dataset.freeShippingLocked || 'Add {remaining} more to unlock the next bundle discount.';
    var secondRewardUnlocked = root.dataset.freeShippingUnlocked || 'Best bundle discount unlocked.';

    var cards = qsa(root, '[data-fk-card]');
    var allCard = qs(root, '[data-fk-all-card]');
    var allButton = qs(root, '[data-fk-all-button]');

    var selectedText = qs(root, '[data-fk-selected-text]');
    var subtotalText = qs(root, '[data-fk-subtotal]');
    var minBar = qs(root, '[data-fk-min-bar]');
    var minNote = qs(root, '[data-fk-min-note]');

    var discountBox = qs(root, '[data-fk-discount-box]');
    var discountBar = qs(root, '[data-fk-discount-bar]');
    var discountNote = qs(root, '[data-fk-discount-note]');

    var secondRewardBox = qs(root, '[data-fk-free-shipping-box]');
    var secondRewardBar = qs(root, '[data-fk-free-shipping-bar]');
    var secondRewardNote = qs(root, '[data-fk-free-shipping-note]');

    var stickyCount = qs(root, '[data-fk-sticky-count]');
    var stickyNote = qs(root, '[data-fk-sticky-note]');
    var addButton = qs(root, '[data-fk-add]');
    var buyNowButton = qs(root, '[data-fk-buy-now]');
    var messageBox = qs(root, '[data-fk-message]');

    function setMessage(text, type) {
      if (!messageBox) return;

      messageBox.textContent = text || '';
      messageBox.classList.toggle('is-error', type === 'error');
      messageBox.classList.toggle('is-success', type === 'success');
    }

    function getCardQty(card) {
      var input = qs(card, '[data-fk-qty]');
      return input ? toInt(input.value, 0) : 0;
    }

    function setCardQty(card, qty) {
      var input = qs(card, '[data-fk-qty]');
      if (!input || input.disabled) return;

      var max = toInt(input.getAttribute('max'), maxPerVariant);
      if (max < 0) max = 0;

      var nextQty = clamp(toInt(qty, 0), 0, max);
      input.value = String(nextQty);

      card.classList.toggle('is-selected', nextQty > 0);

      var quickButton = qs(card, '[data-fk-quick]');
      if (quickButton && !quickButton.disabled) {
        quickButton.textContent = nextQty > 0 ? 'Selected × ' + nextQty : 'Select';
      }
    }

    function getAvailableCards() {
      return cards.filter(function (card) {
        return card.dataset.available === 'true';
      });
    }

    function getSelected() {
      return cards
        .map(function (card) {
          var qty = getCardQty(card);
          var available = card.dataset.available === 'true';

          if (!available || qty <= 0) return null;

          return {
            card: card,
            id: Number(card.dataset.variantId),
            title: card.dataset.variantTitle || '',
            quantity: qty,
            price: toInt(card.dataset.price, 0)
          };
        })
        .filter(Boolean);
    }

    function areAllAvailableSelected() {
      var availableCards = getAvailableCards();

      return (
        availableCards.length > 0 &&
        availableCards.every(function (card) {
          return getCardQty(card) > 0;
        })
      );
    }

    function updateProgressBar(bar, total, threshold) {
      if (!bar) return;

      var percent = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;
      bar.style.width = percent + '%';
    }

    function updateThresholdBox(box, bar, note, total, threshold, lockedText, unlockedText) {
      if (!box || !note) return;

      var remaining = Math.max(0, threshold - total);
      var unlocked = total >= threshold;

      box.classList.toggle('is-unlocked', unlocked);
      updateProgressBar(bar, total, threshold);

      note.textContent = unlocked
        ? unlockedText
        : replaceRemaining(lockedText, remaining);
    }

    function getInlineRewardMessage(totalQty) {
      if (totalQty <= 0) {
        return 'Select variants to build your bundle.';
      }

      if (discountEnabled && totalQty < discountQty) {
        return replaceRemaining(discountLocked, discountQty - totalQty);
      }

      if (
        secondRewardEnabled &&
        secondRewardQty > discountQty &&
        totalQty >= discountQty &&
        totalQty < secondRewardQty
      ) {
        return discountUnlocked + ' ' + replaceRemaining(secondRewardLocked, secondRewardQty - totalQty);
      }

      if (secondRewardEnabled && secondRewardQty > 0 && totalQty >= secondRewardQty) {
        return secondRewardUnlocked;
      }

      if (discountEnabled && totalQty >= discountQty) {
        return discountUnlocked;
      }

      return 'Bundle is ready. You selected ' + totalQty + ' pieces.';
    }

    function updateAllCardState() {
      if (!allCard || !allButton) return;

      var allSelected = areAllAvailableSelected();

      allCard.classList.toggle('is-selected', allSelected);
      allButton.textContent = allSelected ? 'Clear all' : 'Select all';
    }

    function updateUI() {
      var selected = getSelected();

      var totalQty = selected.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);

      var remainingMin = Math.max(0, minQty - totalQty);
      var minUnlocked = totalQty >= minQty;

      if (selectedText) {
        selectedText.textContent = minUnlocked
          ? 'Selected: ' + totalQty
          : 'Selected: ' + totalQty + ' / ' + minQty;
      }

      if (subtotalText) {
        subtotalText.textContent = '';
      }

      updateProgressBar(minBar, totalQty, minQty);

      if (minNote) {
        minNote.textContent = minUnlocked
          ? 'Minimum reached.'
          : 'Add ' + remainingMin + ' more to continue.';
      }

      if (stickyCount) {
        stickyCount.textContent = totalQty + ' selected';
      }

      if (stickyNote) {
        stickyNote.textContent = minUnlocked
          ? 'Ready to add.'
          : 'Add ' + remainingMin + ' more to continue.';
      }

      if (discountEnabled) {
        updateThresholdBox(
          discountBox,
          discountBar,
          discountNote,
          totalQty,
          discountQty,
          discountLocked,
          discountUnlocked
        );
      }

      if (secondRewardEnabled) {
        updateThresholdBox(
          secondRewardBox,
          secondRewardBar,
          secondRewardNote,
          totalQty,
          secondRewardQty,
          secondRewardLocked,
          secondRewardUnlocked
        );
      }

      if (addButton) {
        addButton.disabled = !minUnlocked;
      }

      if (buyNowButton) {
        buyNowButton.disabled = !minUnlocked;
      }

      setMessage(getInlineRewardMessage(totalQty), totalQty >= discountQty ? 'success' : '');

      updateAllCardState();
    }

    function toggleAllVariants() {
      var availableCards = getAvailableCards();
      var allSelected = areAllAvailableSelected();

      availableCards.forEach(function (card) {
        setCardQty(card, allSelected ? 0 : 1);
      });

      updateUI();
    }

    if (allCard) {
      allCard.addEventListener('click', function (event) {
        event.preventDefault();
        toggleAllVariants();
      });

      allCard.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleAllVariants();
        }
      });
    }

    cards.forEach(function (card) {
      var minus = qs(card, '[data-fk-minus]');
      var plus = qs(card, '[data-fk-plus]');
      var input = qs(card, '[data-fk-qty]');
      var quick = qs(card, '[data-fk-quick]');

      if (minus) {
        minus.addEventListener('click', function (event) {
          event.preventDefault();
          setCardQty(card, getCardQty(card) - 1);
          updateUI();
        });
      }

      if (plus) {
        plus.addEventListener('click', function (event) {
          event.preventDefault();
          setCardQty(card, getCardQty(card) + 1);
          updateUI();
        });
      }

      if (input) {
        input.addEventListener('input', function () {
          setCardQty(card, input.value);
          updateUI();
        });

        input.addEventListener('change', function () {
          setCardQty(card, input.value);
          updateUI();
        });
      }

      if (quick) {
        quick.addEventListener('click', function (event) {
          event.preventDefault();

          if (quick.disabled) return;

          var qty = getCardQty(card);
          setCardQty(card, qty > 0 ? 0 : 1);
          updateUI();
        });
      }

      card.addEventListener('click', function (event) {
        if (event.target.closest('button, input, a, label')) return;
        if (card.dataset.available !== 'true') return;

        var qty = getCardQty(card);
        setCardQty(card, qty > 0 ? 0 : 1);
        updateUI();
      });
    });

    function addToCart(goCheckout) {
      var selected = getSelected();

      var totalQty = selected.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);

      if (totalQty < minQty) {
        setMessage('Add ' + (minQty - totalQty) + ' more to unlock the bundle discount.', 'error');
        return;
      }

      var items = selected.map(function (item) {
        return {
          id: item.id,
          quantity: item.quantity
        };
      });

      var clickedButton = goCheckout ? buyNowButton : addButton;
      var normalText = clickedButton ? clickedButton.textContent : '';

      setButtonLoading(clickedButton, true, goCheckout ? 'Preparing checkout...' : 'Adding bundle...');

      fetch(ADD_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              var error = data && (data.description || data.message)
                ? data.description || data.message
                : 'Could not add bundle to cart.';

              throw new Error(error);
            });
          }

          return response.json();
        })
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          updateCartCountBubbles(cart);

          document.dispatchEvent(
            new CustomEvent('fk:mix-bundle:added', {
              detail: {
                cart: cart
              }
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            })
          );

          if (window.FKMixBundleCheckCartGuard) {
            window.FKMixBundleCheckCartGuard();
          }

          announce('Bundle added to cart.');

          if (goCheckout || root.dataset.afterAdd === 'checkout') {
            window.location.href = '/checkout';
            return;
          }

          if (root.dataset.afterAdd === 'stay') {
            setMessage('Bundle added to cart.', 'success');

            cards.forEach(function (card) {
              setCardQty(card, 0);
            });

            updateUI();
            return;
          }

          window.location.href = '/cart';
        })
        .catch(function (error) {
          setMessage(error.message || 'Could not add bundle to cart.', 'error');
        })
        .finally(function () {
          setButtonLoading(clickedButton, false, null, normalText);
          updateUI();
        });
    }

    if (addButton) {
      addButton.addEventListener('click', function () {
        addToCart(false);
      });
    }

    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        addToCart(true);
      });
    }

    updateUI();
  }

  function getCheckoutButtons() {
    var nodes = [];

    [
      'button[name="checkout"]',
      'input[name="checkout"]',
      'a[href="/checkout"]',
      'a[href*="/checkout"]',
      '.cart__checkout-button',
      '.cart-drawer__checkout',
      '[data-checkout-button]'
    ].forEach(function (selector) {
      qsa(document, selector).forEach(function (node) {
        if (nodes.indexOf(node) === -1) nodes.push(node);
      });
    });

    return nodes;
  }

  function getProperty(properties, key) {
    if (!properties) return '';

    if (Object.prototype.hasOwnProperty.call(properties, key)) {
      return properties[key];
    }

    return '';
  }

  function normalizeBoolean(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function getBundleRewardGroups(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];

    var groups = {};

    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var isBundle = getProperty(props, '_fk_mix_bundle') === 'true';

      if (!isBundle) return;

      var group =
        getProperty(props, '_fk_mix_bundle_group') ||
        'ungrouped-' + (getProperty(props, '_fk_mix_bundle_handle') || item.product_id);

      var min = toInt(getProperty(props, '_fk_mix_bundle_min'), 3);
      var title = getProperty(props, '_fk_mix_bundle_title') || item.product_title || 'Bundle';

      var discountEnabled = normalizeBoolean(getProperty(props, '_fk_mix_bundle_discount_enabled'));
      var discountQty = toInt(getProperty(props, '_fk_mix_bundle_discount_qty'), min);

      var discountLocked =
        getProperty(props, '_fk_mix_bundle_discount_locked') ||
        'Add {remaining} more to unlock bundle discount.';

      var discountUnlocked =
        getProperty(props, '_fk_mix_bundle_discount_unlocked') ||
        discountQty + 'pc discount unlocked.';

      var secondEnabled = normalizeBoolean(getProperty(props, '_fk_mix_bundle_second_enabled'));
      var secondQty = toInt(getProperty(props, '_fk_mix_bundle_second_qty'), discountQty * 2);

      var secondLocked =
        getProperty(props, '_fk_mix_bundle_second_locked') ||
        'Add {remaining} more to unlock the next bundle discount.';

      var secondUnlocked =
        getProperty(props, '_fk_mix_bundle_second_unlocked') ||
        'Best bundle discount unlocked.';

      if (!groups[group]) {
        groups[group] = {
          group: group,
          title: title,
          min: min,
          qty: 0,
          discountEnabled: discountEnabled,
          discountQty: discountQty,
          discountLocked: discountLocked,
          discountUnlocked: discountUnlocked,
          secondEnabled: secondEnabled,
          secondQty: secondQty,
          secondLocked: secondLocked,
          secondUnlocked: secondUnlocked
        };
      }

      groups[group].qty += item.quantity || 0;

      groups[group].min = Math.max(groups[group].min, min);
      groups[group].discountQty = Math.max(groups[group].discountQty, discountQty);
      groups[group].secondQty = Math.max(groups[group].secondQty, secondQty);
      groups[group].discountEnabled = groups[group].discountEnabled || discountEnabled;
      groups[group].secondEnabled = groups[group].secondEnabled || secondEnabled;
    });

    return Object.keys(groups)
      .map(function (key) {
        return groups[key];
      })
      .filter(function (group) {
        return group.qty > 0;
      });
  }

  function buildSingleBundleRewardMessage(group) {
    var qty = group.qty;

    var firstQty = group.discountQty || group.min || 3;
    var secondQty = group.secondQty || firstQty * 2;

    var firstEnabled = group.discountEnabled !== false;
    var secondEnabled = group.secondEnabled && secondQty > firstQty;

    if (firstEnabled && qty < firstQty) {
      return replaceRemaining(group.discountLocked, firstQty - qty);
    }

    if (secondEnabled && qty >= firstQty && qty < secondQty) {
      return group.discountUnlocked + ' ' + replaceRemaining(group.secondLocked, secondQty - qty);
    }

    if (secondEnabled && qty >= secondQty) {
      return group.secondUnlocked;
    }

    if (firstEnabled && qty >= firstQty) {
      return group.discountUnlocked;
    }

    return '';
  }

  function buildCartRewardMessage(groups) {
    if (!groups.length) return '';

    if (groups.length === 1) {
      return buildSingleBundleRewardMessage(groups[0]);
    }

    var messages = groups
      .map(function (group) {
        var message = buildSingleBundleRewardMessage(group);
        if (!message) return '';

        return group.title + ': ' + message;
      })
      .filter(Boolean);

    return messages.join(' ');
  }

  function setCheckoutButtonsDisabled(disabled) {
    /*
      Checkout is intentionally never blocked in this version.
      This function only cleans up old disabled states/classes from the previous code.
    */
    getCheckoutButtons().forEach(function (button) {
      if (button.dataset.fkWasEnabled === 'true' && 'disabled' in button) {
        button.disabled = false;
      }

      if (button.dataset.fkMixDisabled === 'true' && 'disabled' in button) {
        button.disabled = false;
      }

      button.classList.remove('fk-mix-checkout-disabled');
      button.removeAttribute('aria-disabled');
      delete button.dataset.fkWasEnabled;
      delete button.dataset.fkMixDisabled;
    });
  }

  function renderCartRewardMessage(message) {
    qsa(document, '.fk-mix-cart-warning, .fk-mix-cart-reward').forEach(function (node) {
      node.remove();
    });

    if (!message) return;

    var checkoutButtons = getCheckoutButtons();

    checkoutButtons.forEach(function (button) {
      var parent =
        button.closest('.cart__footer') ||
        button.closest('.cart-drawer__footer') ||
        button.closest('.drawer__footer') ||
        button.closest('form') ||
        button.parentElement;

      if (!parent || parent.querySelector('.fk-mix-cart-reward')) return;

      var reward = document.createElement('div');
      reward.className = 'fk-mix-cart-reward';
      reward.textContent = message;

      parent.insertBefore(reward, button);
    });
  }

  function checkCartAdvisor() {
    var checkoutButtons = getCheckoutButtons();

    if (!checkoutButtons.length) {
      cartAdvisorState.checked = true;
      cartAdvisorState.message = '';
      return Promise.resolve(cartAdvisorState);
    }

    return fetchCart()
      .then(function (cart) {
        var groups = getBundleRewardGroups(cart);
        var message = buildCartRewardMessage(groups);

        cartAdvisorState.checked = true;
        cartAdvisorState.message = message;

        setCheckoutButtonsDisabled(false);
        renderCartRewardMessage(message);

        return cartAdvisorState;
      })
      .catch(function () {
        setCheckoutButtonsDisabled(false);
        return cartAdvisorState;
      });
  }

  /*
    Keep this old global name for compatibility with existing bundle add-to-cart code.
    It no longer blocks checkout. It only updates discount messages.
  */
  window.FKMixBundleCheckCartGuard = checkCartAdvisor;

  function debounce(fn, wait) {
    var timer = null;

    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  var debouncedCartAdvisor = debounce(checkCartAdvisor, 450);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"], input[name^="updates"], quantity-input input, .quantity__input') ||
      event.target.closest('cart-drawer, .cart-drawer, form[action="/cart"]')
    ) {
      debouncedCartAdvisor();
    }
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('button[name="plus"], button[name="minus"], .quantity__button, cart-remove-button, a[href*="/cart/change"]') ||
      event.target.closest('cart-drawer, .cart-drawer, form[action="/cart"]')
    ) {
      debouncedCartAdvisor();
    }
  });

  document.addEventListener('fk:mix-bundle:added', function () {
    debouncedCartAdvisor();
  });

  document.addEventListener('cart:updated', function () {
    debouncedCartAdvisor();
  });

  document.addEventListener('DOMContentLoaded', function () {
    qsa(document, '[data-fk-mix-bundle]').forEach(initMixBundle);
    checkCartAdvisor();
  });

  document.addEventListener('shopify:section:load', function (event) {
    qsa(event.target, '[data-fk-mix-bundle]').forEach(initMixBundle);
    debouncedCartAdvisor();
  });
})();

/* =========================================================
   FK Mix Bundle — Sticky Buy Now V2

   - Desktop: fixed to visible bottom of the bundle block area.
   - Mobile: fixed to bottom of screen.
   - Only Buy Now is sticky.
   - Add to Cart is never duplicated or made sticky.
   - Uses the real existing [data-fk-buy-now] button.
   ========================================================= */

(function () {
  if (window.FKMixBundleStickyBuyNowV2Loaded) return;
  window.FKMixBundleStickyBuyNowV2Loaded = true;

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root ? root.querySelectorAll(selector) : []);
  }

  function toInt(value, fallback) {
    var num = parseInt(value, 10);
    return Number.isFinite(num) ? num : fallback;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getSelectedQty(root) {
    return qsa(root, '[data-fk-card] [data-fk-qty]').reduce(function (sum, input) {
      if (!input || input.disabled) return sum;

      var qty = toInt(input.value, 0);
      return sum + Math.max(0, qty);
    }, 0);
  }

  function getOriginalBuyNow(root) {
    return qs(root, '.fk-mix__inline-actions [data-fk-buy-now]');
  }

  function removeOldStickyPatch(root) {
    qsa(root, '[data-fk-sticky-buy-now-bar]').forEach(function (oldBar) {
      oldBar.remove();
    });
  }

  function syncStickyPosition(root, stickyBar) {
    if (!root || !stickyBar) return;

    var rect = root.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    var visibleVertically = rect.bottom > 80 && rect.top < viewportHeight - 40;

    stickyBar.classList.toggle('fk-mix-sticky-buy-v2--in-view', visibleVertically);

    if (!visibleVertically) return;

    if (isMobile()) {
      stickyBar.style.removeProperty('--fk-sticky-buy-v2-left');
      stickyBar.style.removeProperty('--fk-sticky-buy-v2-width');
      stickyBar.style.removeProperty('--fk-sticky-buy-v2-bottom');
      return;
    }

    var sideInset = 0;
    var left = Math.max(sideInset, rect.left);
    var width = Math.max(220, Math.min(rect.width, window.innerWidth - sideInset * 2));

    var normalBottom = 16;
    var sectionBottomLimit = Math.max(normalBottom, viewportHeight - rect.bottom + 12);
    var finalBottom = Math.min(sectionBottomLimit, viewportHeight - 90);

    stickyBar.style.setProperty('--fk-sticky-buy-v2-left', left + 'px');
    stickyBar.style.setProperty('--fk-sticky-buy-v2-width', width + 'px');
    stickyBar.style.setProperty('--fk-sticky-buy-v2-bottom', finalBottom + 'px');
  }

  function syncStickyBuyNow(root) {
    if (!root) return;

    var originalBuyNow = getOriginalBuyNow(root);
    var stickyBar = qs(root, '[data-fk-sticky-buy-now-v2-bar]');
    var stickyButton = qs(root, '[data-fk-sticky-buy-now-v2]');

    if (!originalBuyNow || !stickyBar || !stickyButton) return;

    var totalQty = getSelectedQty(root);
    var minQty = Math.max(1, toInt(root.dataset.minQty, 1));
    var remainingQty = Math.max(0, minQty - totalQty);

    var hasSelection = totalQty > 0;
    var minimumReached = totalQty >= minQty;
    var originalBusy = originalBuyNow.getAttribute('aria-busy') === 'true';

    root.classList.toggle('fk-mix-has-sticky-buy-v2', hasSelection);

    stickyBar.hidden = !hasSelection;
    stickyBar.setAttribute('aria-hidden', hasSelection ? 'false' : 'true');

    if (!hasSelection) {
      stickyButton.disabled = true;
      stickyButton.textContent = 'Buy bundle now';
      stickyButton.removeAttribute('aria-busy');
      syncStickyPosition(root, stickyBar);
      return;
    }

    stickyButton.disabled = !minimumReached || originalBuyNow.disabled || originalBusy;

    if (originalBusy) {
      stickyButton.setAttribute('aria-busy', 'true');
      stickyButton.textContent = originalBuyNow.textContent.trim() || 'Preparing checkout...';
    } else {
      stickyButton.removeAttribute('aria-busy');

      if (minimumReached) {
        stickyButton.textContent = 'Buy bundle now';
      } else {
        stickyButton.textContent = 'Add ' + remainingQty + ' more to buy';
      }
    }

    stickyButton.setAttribute(
      'aria-label',
      minimumReached
        ? 'Buy selected bundle now'
        : 'Add ' + remainingQty + ' more item' + (remainingQty === 1 ? '' : 's') + ' to buy'
    );

    syncStickyPosition(root, stickyBar);
  }

  function scheduleSync(root) {
    if (!root) return;

    if (root.__fkStickyBuyNowV2Frame) {
      window.cancelAnimationFrame(root.__fkStickyBuyNowV2Frame);
    }

    root.__fkStickyBuyNowV2Frame = window.requestAnimationFrame(function () {
      syncStickyBuyNow(root);
    });
  }

  function initStickyBuyNowV2(root) {
    if (!root || root.dataset.fkStickyBuyNowV2Ready === 'true') return;

    var originalBuyNow = getOriginalBuyNow(root);

    if (!originalBuyNow) return;

    removeOldStickyPatch(root);

    var stickyBar = document.createElement('div');
    stickyBar.className = 'fk-mix-sticky-buy-v2';
    stickyBar.setAttribute('data-fk-sticky-buy-now-v2-bar', '');
    stickyBar.setAttribute('aria-hidden', 'true');
    stickyBar.hidden = true;

    var stickyButton = document.createElement('button');
    stickyButton.type = 'button';
    stickyButton.className = 'fk-mix__button fk-mix__button--secondary fk-mix-sticky-buy-v2__button';
    stickyButton.setAttribute('data-fk-sticky-buy-now-v2', '');
    stickyButton.disabled = true;
    stickyButton.textContent = 'Buy bundle now';

    stickyBar.appendChild(stickyButton);
    root.appendChild(stickyBar);

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (stickyButton.disabled) return;

      originalBuyNow.click();
      scheduleSync(root);
    });

    root.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || !target.closest) return;

      if (
        target.closest('[data-fk-card]') ||
        target.closest('[data-fk-all-card]') ||
        target.closest('[data-fk-minus]') ||
        target.closest('[data-fk-plus]') ||
        target.closest('[data-fk-quick]') ||
        target.closest('[data-fk-all-button]')
      ) {
        scheduleSync(root);
      }
    });

    root.addEventListener('input', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-fk-qty]')) {
        scheduleSync(root);
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('[data-fk-qty]')) {
        scheduleSync(root);
      }
    });

    window.addEventListener('scroll', function () {
      scheduleSync(root);
    }, { passive: true });

    window.addEventListener('resize', function () {
      scheduleSync(root);
    });

    window.addEventListener('orientationchange', function () {
      scheduleSync(root);
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        scheduleSync(root);
      });

      observer.observe(originalBuyNow, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['disabled', 'aria-busy']
      });
    }

    root.dataset.fkStickyBuyNowV2Ready = 'true';
    scheduleSync(root);
  }

  function initAllStickyBuyNowV2(scope) {
    qsa(scope || document, '[data-fk-mix-bundle]').forEach(initStickyBuyNowV2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllStickyBuyNowV2(document);
    });
  } else {
    initAllStickyBuyNowV2(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllStickyBuyNowV2(event.target);
  });
})();